<template>
  <div>
    <md-card>
      <md-card-header>
        <span class="md-title">{{ month }} {{ L('cost') }}</span>
      </md-card-header>
      <md-card-content>{{ cost | formatCurrency(currency) }}</md-card-content>
      <md-card-actions>{{ fromDate }} ~ {{ toDate }}</md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    currency: String,
  },

  computed: {
    month() {
      return this.data ? this.data.month || '' : ''
    },

    fromDate() {
      return this.data ? this.data.fromDate || '' : ''
    },

    toDate() {
      return this.data ? this.data.toDate || '' : ''
    },

    cost() {
      return this.data ? this.data.cost || 0 : 0
    },
  },
}
</script>

<style lang="scss" scoped>
.md-card {
  display: flex;
  flex-direction: column;
}

.md-card-content {
  flex: 100;
}
</style>
